import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'; 

@Pipe({
  name: 'qdatetime'
})
export class QdatetimePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    var format = "DD-MM-YYYY hh:mm a";
    //console.log ("argas --->", args);
    if(args){
      format = args;
    }
    if(!value){
      return "";
    }
    //console.log ("and format is ..", format);
    return moment(value).format(format);
  }

}
